import { render, staticRenderFns } from "./ListAndDemandSearch.vue?vue&type=template&id=9b4e4a14&scoped=true&"
import script from "./ListAndDemandSearch.vue?vue&type=script&lang=js&"
export * from "./ListAndDemandSearch.vue?vue&type=script&lang=js&"
import style0 from "./ListAndDemandSearch.vue?vue&type=style&index=0&id=9b4e4a14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b4e4a14",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/pc/Documents/Programs/Vue/top-ten-naija/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {VCard,VCardActions,VCardText,VLayout,VSpacer})
